<template>
  <NuxtLink
    :to="`/${slug}`"
    v-editable="article"
    class="card flex flex-col justify-between w-full rounded-2xl overflow-clip border border-grey-2 bg-white hover:cursor-pointer hover:bg-light-green h-full"
  >
    <div class="h-[150px] md:h-[180px]">
      <NuxtImg
        v-if="article?.image?.filename"
        class="w-full h-full object-cover"
        provider="storyblok"
        :src="article.image.filename"
        :alt="article.title"
        format="webp"
        width="400px"
        height="400px"
        lazy
      />
      <div v-else class="w-full h-full bg-gray-100"></div>
    </div>
    <div class="flex-grow p-3">
      <h3 class="font-bold">{{ article?.title || 'Untitled' }}</h3>
      <div class="line-clamp-1" v-html="truncatedContent"></div>
    </div>
  </NuxtLink>
</template>

<script setup lang="ts">
const props = defineProps({
  article: {
    type: Object,
    required: true
  },
  slug: {
    type: String,
    required: true
  }
});

const { stripFormatting } = useSanitisedRichText();

const truncatedContent = computed(() => {
  if (!props.article?.content) return '';
  
  const fullText = stripFormatting(renderRichText(props.article.content));
  return fullText.split(' ').slice(0, 20).join(' ') + '...';
});
</script> 